import { createReducer } from '../../util/redux';

/*
 |--------------------------------------------------------------------------
 | Default state
 |--------------------------------------------------------------------------
 */

const defaultState = [];

/*
 |--------------------------------------------------------------------------
 | Actions - anything that changes the store
 |--------------------------------------------------------------------------
 */

/*
 |--------------------------------------------------------------------------
 | Thunks - same as actions but returns a promise. Good for chaining
 |--------------------------------------------------------------------------
 */

/*
 |--------------------------------------------------------------------------
 | Reducer - maps the action to the action handler
 |--------------------------------------------------------------------------
 */

export const announcementReducer = createReducer(defaultState, {});

/*
 |--------------------------------------------------------------------------
 | Action Exports
 |--------------------------------------------------------------------------
 */
export default {};
